import { Outlet } from 'react-router-dom';
import NavbarComponent from 'components/NavbarComponent';
import StylQuoterLayout from "../scss/quoterLayout.module.scss";
const QuoterLayout = () => {

  return (
    <div className={StylQuoterLayout.quoterLayout}>
    <NavbarComponent />
     <section className={StylQuoterLayout.content}>
      <Outlet />
     </section>
    </div>
  );
};

export default QuoterLayout;
